// ModalMissingInformation.js
import React, { Component } from 'react';
import classNames from 'classnames';

import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { ensureCurrentUser } from '../../util/data';
import { isUserAuthorized } from '../../util/userHelpers';
import { pathByRouteName } from '../../util/routes';

import { Modal } from '../../components';
import modalCss from '../Modal/Modal.module.css';

import EmailReminder from './EmailReminder';
import css from './ModalMissingInformation.module.css';

import {
  EMAIL_VERIFICATION,
  MISSING_INFORMATION_MODAL_WHITELIST,
  resolveHideCloseButton,
  resolveMissingInformationReminderWithForce,
} from '../../util/missingInformationModal';

class ModalMissingInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMissingInformationReminder: null,
      hasSeenMissingInformationReminder: false,
    };
    this.handleMissingInformationReminder = this.handleMissingInformationReminder.bind(this);
  }

  componentDidUpdate() {
    const { currentUser, currentUserHasListings, currentUserHasOrders, location } = this.props;
    const user = ensureCurrentUser(currentUser);

    this.handleMissingInformationReminder(
      user,
      currentUserHasListings,
      currentUserHasOrders,
      location
    );
  }

  handleMissingInformationReminder(
    currentUser,
    currentUserHasListings,
    currentUserHasOrders,
    newLocation
  ) {
    const { forceOpenEmailVerification } = this.props;

    const routes = this.props.routeConfiguration;
    const whitelistedPaths = MISSING_INFORMATION_MODAL_WHITELIST.map(page =>
      pathByRouteName(page, routes)
    );

    const isPageWhitelisted = whitelistedPaths.includes(newLocation.pathname);

    const pathChanged = newLocation.pathname !== this.props.location.pathname;
    const notRemindedYet =
      !this.state.showMissingInformationReminder && !this.state.hasSeenMissingInformationReminder;

    const showOnPathChange = notRemindedYet || pathChanged;

    if (!isPageWhitelisted && showOnPathChange) {
      const reminder = resolveMissingInformationReminderWithForce({
        currentUser,
        currentUserHasListings,
        currentUserHasOrders,
        forceOpenEmailVerification,
      });

      if (reminder) {
        this.setState({ showMissingInformationReminder: reminder });
      }
    }
  }

  render() {
    const {
      rootClassName,
      className,
      containerClassName,
      closeButtonAriaLabel,
      currentUser,
      sendVerificationEmailInProgress,
      sendVerificationEmailError,
      onManageDisableScrolling,
      onResendVerificationEmail,
      location,
      forceOpenEmailVerification,
    } = this.props;

    const user = ensureCurrentUser(currentUser);
    const classes = classNames(rootClassName || css.root, className);

    let content = null;

    const currentUserLoaded = user && user.id;
    if (currentUserLoaded && isUserAuthorized(currentUser)) {
      if (this.state.showMissingInformationReminder === EMAIL_VERIFICATION) {
        content = (
          <EmailReminder
            className={classes}
            user={user}
            onResendVerificationEmail={onResendVerificationEmail}
            sendVerificationEmailInProgress={sendVerificationEmailInProgress}
            sendVerificationEmailError={sendVerificationEmailError}
            forceOpenEmailVerification={forceOpenEmailVerification}
          />
        );
      }
    }

    const closeButtonMessage = (
      <FormattedMessage id="ModalMissingInformation.closeVerifyEmailReminder" />
    );

    const hideCloseButton = forceOpenEmailVerification
      ? false
      : resolveHideCloseButton(location?.pathname);

    return (
      <Modal
        id="MissingInformationReminder"
        containerClassName={classNames(modalCss.container, css.modalContainer, containerClassName)}
        contentClassName={classNames(modalCss.content, css.modalContent)}
        isOpen={!!this.state.showMissingInformationReminder}
        onClose={() => {
          this.setState({
            showMissingInformationReminder: null,
            hasSeenMissingInformationReminder: true,
          });
        }}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        closeButtonMessage={closeButtonMessage}
        closeButtonAriaLabel={closeButtonAriaLabel}
        hideCloseButton={hideCloseButton}
      >
        {content}
      </Modal>
    );
  }
}

const EnhancedModalMissingInformation = props => {
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const closeButtonAriaLabel = intl.formatMessage({
    id: 'ModalMissingInformation.closeVerificationPopup',
    defaultMessage: 'Close verification popup',
  });

  return (
    <ModalMissingInformation
      routeConfiguration={routeConfiguration}
      closeButtonAriaLabel={closeButtonAriaLabel}
      {...props}
    />
  );
};

export default EnhancedModalMissingInformation;
